import type { CSSProperties, FC } from 'react';
import styles from './Skeleton.module.css';

type Props = {
    width: CSSProperties['width'];
    height: CSSProperties['height'];
};

export const Skeleton: FC<Props> = ({ width, height }) => (
    <div className={styles.skeleton} style={{ width, height }} />
);
